import { Link } from "react-router-dom"
import Button from "../../components/ui/Button"
import Title from "../../components/ui/Title"
import '../../styles/ui/ui.scss'
import '../../styles/pages/system.scss'

const Support = () => {
    return (
        <div className="page-cotanier">
            <div className="line-container">
            <Title
                text="System"
                size="full"
            />
            <header className="system-header">
                <h1 className="system-title">
                    Complete support requests to level up as a detective!
                </h1>
                <p>
                    As part of his duties as a member of the Special Support Section, Lloyd will receive various requests from the citizens of Crossbell. Take on these requests to move up in the ranks as a detective!
                </p>
            </header>
            <div className="system-pair">
                <div className="system-info">
                    <h1 className="system-info_title">
                        Special Support Section, move out!
                    </h1>
                    <p>
                        As you progress through the main story, you may also receive various requests for assistance from citizens. These are known as support requests and can involve a number of different tasks, ranging from monster extermination to changing a lightbulb out on the highway, to proper policework, such as investigating a stalker. By completing support requests, you'll see a new side of Crossbell and satisfied citizens may even reward you with some special items as thanks.
                    </p>
                </div>
            </div>
            <div className="system-pair"  style={{paddingBottom: '25px'}}>
                <div className="system-info">
                    <h1 className="system-info_title">
                        Illegal Parking Crackdown
                    </h1>
                    <p>
                        The recent rise in orbal cars in Crossbell City means there's been an equal rise in illegally-parked orbal cars. After accepting a request for help from the CPD's Metropolitan Division, Lloyd and the SSS work to sort out which cars have permits and issue tickets to those that don't.
                    </p>
                </div>
                <div className="system-info_image">
                    <img src={`${process.env.PUBLIC_URL}/img/ss/support-2.webp`} alt="AT Battle Images" />
                </div>
            </div>
            <div className="system-pair"  style={{paddingBottom: '25px'}}>
                <div className="system-info">
                    <h1 className="system-info_title">
                        Stalker Investigation
                    </h1>
                    <p>
                        An unknown stalker has recently been spotted spying on the star of Arc en Ciel, Ilya Platiere. Is this stalker simply an overzealous fan, or do they hold some personal grudge against the Fervent Dancer?
                    </p>
                </div>
                <div className="system-info">
                    <h1 className="system-info_title">
                        Detective Ranks
                    </h1>
                    <p>
                        After completing a support request, you can report your results to CPD headquarters via the terminal at the SSS building to earn DP (Detective Points) and receive your pay for a job well done. Once you've accumulated enough DP, you will advance to the next rank, earning you special bonus items from HQ.                    
                    </p>
                    <br/>
                    <p>
                        Most support requests can be started from the terminal at your base, but there are several requests that can only be found with a bit of legwork. These hidden requests will only start after you've completed specific events or talked to specific people at the right time.
                    </p>

                </div>
                <div className="system-info_image">
                    <img src={`${process.env.PUBLIC_URL}/img/ss/support-3.webp`} alt="AT Battle Images" />
                </div>
            </div>
            <Link to="/system">
                <Button
                    text="Go Back"
                    type="solid"
                    color="blue"

                    style={{
                        backgroundImage: 'linear-gradient(#2770ac,#008cff)',
                        border: '2px solid #fff',
                        borderRadius: '10px',
                        color: '#fff',
                        cursor: 'pointer',
                        filter: 'drop-shadow(0 0 4px rgba(0,0,0,.2))',
                        fontFamily: 'Bookmania',
                        fontSize: '1.25em',
                        height: '50px',
                        minWidth: '150px',
                        padding: '5px 25px 0',
                        transition: '.5s'
                    }}
                />
            </Link>
            </div>
        </div>
    )
}

export default Support